import { combineReducers } from 'redux';
import blog from './blog'
import user from './user'
import post from './contents/post'
import page from './contents/page'
import notice from './contents/notice'
import keyword from './contents/keyword'
import template from './contents/template'
import comment from './comment/comment'
import commentTrash from './comment/commentTrash'
import guestbookComment from './comment/guestbookComment'
import guestbookCommentTrash from './comment/guestbookCommentTrash'
import teamblog from './setting/teamblog';
import category from './contents/category'
import sidebar from './design/sidebar'
import blogmenu from './design/blogmenu'
import link from './link'
import popup from './common/popup'
import plugins from './plugins'
import setting from './setting'
import statistics from './statistics/statisticsReducers';
import revenue from './revenue'

export default combineReducers({
	post,
	page,
  notice,
	keyword,
	template,
	comment,
	commentTrash,
	guestbookComment,
	guestbookCommentTrash,
	category,
	sidebar,
	blogmenu,
	link,
	popup,
	plugins,
	setting,
	blog,
  teamblog,
	user,
  statistics,
	revenue,
})
